import { render, staticRenderFns } from "./plmRoutingRelease.vue?vue&type=template&id=0e78a57c&scoped=true"
import script from "./plmRoutingRelease.vue?vue&type=script&lang=js"
export * from "./plmRoutingRelease.vue?vue&type=script&lang=js"
import style0 from "./plmRoutingRelease.vue?vue&type=style&index=0&id=0e78a57c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e78a57c",
  null
  
)

export default component.exports